<template>
  <div class="data-download-box w-full h-full p-4 box-border overflow-hidden">
    <div class="card h-full p-5 box-border bg-white shadow-theme rounded">
      <div class="card-body h-full overflow-hiddle box-border">
        <!-- <ul class="mb-2 border-b border-solid" style="border-color: #e7e9eb">
          <router-link
            v-for="menu in menus"
            tag="li"
            :to="menu.path"
            :key="menu.meta.id"
            class="cursor-pointer leading-22 text-theme-black-650 text-medium inline-block px-6 py-3"
          >
            {{ menu.meta.label }}
          </router-link>
        </ul>
        <div class="main-box w-full pl-5 pr-5 box-border overflow-auto" style="height: calc(100% - 57px)">
          <router-view></router-view>
        </div> -->
        <AllDownload/>
      </div>
    </div>
  </div>
</template>

<script>
import AllDownload from './data-download/AllDownload'
export default {
  name: 'DataDownload',
  components: { AllDownload },
  data() {
    return {}
  },
  methods: {},
  created() {
    this.menus = this.$dygcRouter.getChildrenByName('data-download')
  }
}
</script>
<style lang="scss" scoped>
.data-download-box {
  // .router-link-active {
  //   @apply text-theme border-theme border-b border-solid;
  // }
/* 
  ::v-deep.el-card .el-card__body {
    height: calc(100% - 50px);
  } */
}
</style>
